module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container room-details"
  }, [_c('div', {
    staticClass: "room-grid"
  }, [_c('div', {
    staticClass: "no",
    on: {
      "click": function($event) {
        _vm.goto_room(_vm.room.no)
      }
    }
  }, [_vm._v(_vm._s(_vm.room.no))]), _c('table', {
    staticClass: "ui very basic unstackable compact collapsing table info"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("状态")]), (_vm.room.category) ? _c('td', {
    staticClass: "hide-in-mobile"
  }, [_vm._v("楼层")]) : _vm._e(), (_vm.room._type) ? _c('td', {
    staticClass: "hide-in-mobile"
  }, [_vm._v("户型")]) : _vm._e(), _c('td', [_vm._v("月租价格")]), (_vm.room.price_day) ? _c('td', [_vm._v("日租价格")]) : _vm._e(), _c('td')]), _c('tr', [_c('td', [_c('div', {
    staticClass: "ui label",
    class: _vm.$formatters.state_class(_vm.state)
  }, [_vm._v(_vm._s(_vm.$formatters.state_label(_vm.state)))])]), (_vm.room.category) ? _c('td', {
    staticClass: "hide-in-mobile"
  }, [_vm._v(_vm._s(_vm.room.category))]) : _vm._e(), (_vm.room._type) ? _c('td', {
    staticClass: "hide-in-mobile"
  }, [_vm._v(_vm._s(_vm.room._type.name))]) : _vm._e(), _c('td', [_vm._v(_vm._s(_vm.room.price_month))]), (_vm.room.price_day) ? _c('td', [_vm._v(_vm._s(_vm.room.price_day))]) : _vm._e(), _c('td', [(_vm.available_preorders && _vm.available_preorders.length) ? [_c('el-popover', {
    ref: "preorders",
    attrs: {
      "placement": "bottom",
      "width": "500",
      "trigger": "hover"
    }
  }, [_c('h3', [_vm._v("预订单")]), _c('auto-table', {
    attrs: {
      "defines": _vm.$defines.preorder,
      "data": _vm.available_preorders,
      "unstackable": "unstackable",
      "detail-view": true,
      "actions": "order"
    },
    on: {
      "action:order": _vm.goto_preorder
    }
  })], 1)] : _vm._e(), _c('el-popover', {
    ref: "properties",
    attrs: {
      "placement": "bottom",
      "width": "650",
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "with-actions"
  }, [_c('h3', [_vm._v("物品清单")]), _c('div', {
    staticClass: "ui tiny buttons actions"
  }, [_c('div', {
    staticClass: "ui basic button icon",
    on: {
      "click": _vm.print_properties
    }
  }, [_c('i', {
    staticClass: "print icon themed text"
  })])])]), _c('room-properties', {
    attrs: {
      "properties": _vm.room.properties,
      "pagesize": 15,
      "compact": true
    }
  })], 1), _c('el-popover', {
    ref: "utilities",
    attrs: {
      "placement": "bottom",
      "width": "600",
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "with-actions"
  }, [_c('h3', [_vm._v("水电表")]), _c('div', {
    staticClass: "ui tiny buttons actions"
  }, [_c('div', {
    staticClass: "ui basic button icon",
    on: {
      "click": _vm.goto_utilities
    }
  }, [_c('i', {
    staticClass: "pencil icon themed text"
  })])])]), _vm._l((_vm.room.utilities), function(utility, index) {
    return _c('utility-view', {
      key: index,
      attrs: {
        "paid": _vm.room.utilities_paid,
        "data": utility
      }
    })
  })], 2), _c('el-popover', {
    ref: "history_notes",
    attrs: {
      "placement": "bottom",
      "width": "600",
      "trigger": "hover"
    }
  }, [_c('h3', [_vm._v("房屋记录")]), _c('auto-table', {
    attrs: {
      "defines": _vm.$defines.history_notes,
      "data": _vm.room.history_notes || []
    }
  })], 1), _c('div', {
    staticClass: "ui buttons"
  }, [(_vm.available_preorders && _vm.available_preorders.length) ? [(_vm.$media.isMobile) ? _c('div', {
    staticClass: "ui icon small basic button",
    on: {
      "click": _vm.goto_overview
    }
  }, [_c('i', {
    staticClass: "icon pin themed text"
  }), _c('span', {
    staticClass: "themed text"
  }, [_vm._v(_vm._s(_vm.available_preorders.length))])]) : _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:preorders",
      arg: "preorders"
    }],
    staticClass: "ui icon small basic button",
    on: {
      "click": _vm.goto_overview
    }
  }, [_c('i', {
    staticClass: "icon pin themed text"
  }), _c('span', {
    staticClass: "themed text"
  }, [_vm._v(_vm._s(_vm.available_preorders.length))])])] : [_c('div', {
    staticClass: "ui icon small basic button",
    attrs: {
      "data-tooltip": "预定房间",
      "data-position": "top center",
      "data-inverted": ""
    },
    on: {
      "click": _vm.goto_new_preorder
    }
  }, [_c('i', {
    staticClass: "icon pin"
  })])], _c('div', {
    staticClass: "ui icon small basic button",
    attrs: {
      "data-tooltip": "全部合同",
      "data-position": "top center",
      "data-inverted": ""
    },
    on: {
      "click": _vm.goto_overview
    }
  }, [_c('i', {
    staticClass: "icon archive"
  })]), (_vm.current_contract) ? _c('div', {
    staticClass: "ui icon small basic button",
    attrs: {
      "data-tooltip": "当前合同",
      "data-position": "top center",
      "data-inverted": ""
    },
    on: {
      "click": _vm.goto_current_contract
    }
  }, [_c('i', {
    staticClass: "icon file"
  })]) : _vm._e(), _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:properties",
      arg: "properties"
    }],
    staticClass: "ui icon small basic button hide-in-mobile",
    on: {
      "click": function($event) {
        _vm.goto_room_edit(_vm.room.no)
      }
    }
  }, [_c('i', {
    staticClass: "icon cubes"
  }), _c('span', [_vm._v(_vm._s((_vm.room.properties || []).length))])]), (_vm.$media.isMobile) ? _c('div', {
    staticClass: "ui icon small basic button",
    on: {
      "click": _vm.goto_utilities
    }
  }, [_c('i', {
    staticClass: "icon lightning"
  })]) : _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:utilities",
      arg: "utilities"
    }],
    staticClass: "ui icon small basic button",
    on: {
      "click": _vm.goto_utilities
    }
  }, [_c('i', {
    staticClass: "icon lightning"
  })]), _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:history_notes",
      arg: "history_notes"
    }],
    staticClass: "ui icon small basic button hide-in-mobile",
    on: {
      "click": function($event) {
        _vm.goto_room_edit(_vm.room.no)
      }
    }
  }, [_c('i', {
    staticClass: "icon sticky note"
  })]), _c('div', {
    staticClass: "ui icon small basic button hide-in-mobile",
    attrs: {
      "data-tooltip": "修改房间信息",
      "data-position": "top center",
      "data-inverted": ""
    },
    on: {
      "click": function($event) {
        _vm.goto_room_edit(_vm.room.no)
      }
    }
  }, [_c('i', {
    staticClass: "icon pencil"
  })])], 2)], 2)])])])]), ((_vm.room.tracking_notes || []).length) ? [_c('el-collapse', {
    attrs: {
      "value": 1
    }
  }, [(_vm.pending_notes.length) ? _c('el-collapse-item', {
    attrs: {
      "title": ("待处理 (" + (_vm.pending_notes.length) + ")"),
      "name": 1
    }
  }, [_c('notes-list', {
    attrs: {
      "notes": _vm.pending_notes
    },
    on: {
      "open": function($event) {
        _vm.dialog_tracking_notes = true
      }
    }
  })], 1) : _vm._e(), (_vm.checked_notes.length) ? _c('el-collapse-item', {
    attrs: {
      "title": ("已处理 (" + (_vm.checked_notes.length) + ")"),
      "name": 2
    }
  }, [_c('notes-list', {
    attrs: {
      "notes": _vm.checked_notes
    },
    on: {
      "open": function($event) {
        _vm.dialog_tracking_notes = true
      }
    }
  })], 1) : _vm._e()], 1), _c('dialog-tracking-notes', {
    attrs: {
      "visible": _vm.dialog_tracking_notes,
      "room": _vm.room
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_tracking_notes = $event
      }
    }
  })] : _vm._e(), (_vm.$config.logic.lezhu_meter && _vm.room.lezhu_meter_id) ? [_c('lezhu-monitor', {
    attrs: {
      "room": _vm.room
    }
  })] : _vm._e(), _c('router-view')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3195feaa","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/pages/Room.vue
// module id = 451
// module chunks = 0